export const formatLabel = (value?: string | null) => {
  if (!value) return ''

  const customLabels: Record<string, string> = {
    admin: 'Admin',
    operador: 'Operador',
    superadmin: 'Super Admin',
    disponible: 'Disponible',
    en_uso: 'En uso',
    lavanderia: 'Lavandería',
  }

  if (customLabels[value]) {
    return customLabels[value]
  }

  return value.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
}
